<template>
    <AuthLayout>
        <div class="md:py-12 md:px-8 w-full max-w-lg p-6 mx-auto bg-white border rounded-lg shadow-sm">
            <h2 class="mt-0 mb-2 text-2xl font-bold leading-9 tracking-tight text-center text-gray-700">
                {{ $t('passwords.reset_password') }}
            </h2>
            <p class="mb-8 text-center" v-html="$t('passwords.reset_password_details', { email: initialEmail, emphasizedOpen: '<span class=&quot;font-semibold&quot;>', emphasizedClose: '</span>' })"></p>
            <div class="md:w-1/3 w-1/2 pb-10 mx-auto">
                <svg-my-password></svg-my-password>
            </div>
            <div v-if="status" class="mb-8">
                <div class="p-4 bg-gray-200 border-l-4 border-gray-500 rounded shadow" :class="{ 'border-blue-500': status.type === 'success', 'border-danger-500': status.type === 'danger' }" role="alert">
                    <p v-if="status.type === 'success'" class="mb-0" v-html="$t('passwords.reset', { linkOpen: '<a class=&quot;ml-1 pointed-at&quot; href=&quot;/dashboard&quot;>', linkClose: '</a>' })"></p>
                    <p v-else class="mb-0">{{ status.message }}</p>
                </div>
            </div>
            <form class="w-full" @submit.prevent="onSubmit" @keydown="form.errors.forget($event.target.name)">
                <div class="mb-3" :class="{ 'has-error' : form.errors.has('password') }">
                    <label class="mb-1" for="password">{{ $t('passwords.new_password') }}</label>
                    <div class="input-group">
                        <input class="form-control" id="password" name="password" :placeholder="$t('sign_up.password_placeholder')" :type="passwordFieldType"  v-model="form.password" />
                        <span class="input-group-addon">
                            <label class="custom-control custom-control-blue-500 custom-checkbox">
                                <input class="custom-control-input" type="checkbox" v-model="passwordFieldType" true-value="text" false-value="password" @click="switchPasswordVisibility">
                                <span class="custom-control-indicator"></span>
                                <span class="custom-control-label">{{ $t('auth.show') }}</span>
                            </label>
                        </span>
                    </div>
                    <p class="help-block" v-if="form.errors.has('password')" v-text="form.errors.get('password')"></p>
                </div>
                <div class="pt-2">
                    <button class="btn btn-block btn-primary-blue" type="submit">{{ $t('passwords.reset_password') }}</button>
                </div>
            </form>
        </div>
    </AuthLayout>
</template>

<script>
import AuthLayout from '../layouts/AuthLayout.vue';
import SvgMyPassword from '../../../svg/my-password.vue';

export default {
    components: {
        AuthLayout,
        'svg-my-password': SvgMyPassword,
    },

    props: {
        initialToken: String,
        initialEmail: String,
    },

    data() {
        return {
            form: new Form({
                token: this.initialToken,
                email: this.initialEmail,
                password: '',
                password_confirmation: '',
            }),
            passwordFieldType: 'password',
            status: null,
        };
    },

    watch: {
        'form.password': function(value, old) {
            this.form.password_confirmation = value;
        },
    },

    methods: {
        switchPasswordVisibility() {
            this.passwordFieldType = this.passwordFieldType == 'password' ? 'text' : 'password';
        },

        onSubmit() {
            Globals.post('/password/reset', this.form)
                .then(response => this.status = response)
                .catch(() => this.status = null);
        },
    },
};
</script>
